module.exports = {
    RECEIVE_ALL_QUALITOMETER_REPRESENTIVENESS: 'RECEIVE_ALL_QUALITOMETER_REPRESENTIVENESS',
}
